import React from 'react'
import './newyork_customers.scss'
const NewyorkCustomer = () => {
    const listtems = [
        {
            text: 'Acceptable notification is either a reasonable request in writing or a protective order for accident and health insurance or a valid order of protection for non-accident and health insurance. This can come from either the covered individual, their legal representative, or if a child, the child’s parent or guardian.'
        },
        {
            text: 'Sentry will not disclose the address or telephone number of the individual or any child residing with the individual unless the request for confidentiality has been revoked or express consent has been given by the individual.'
        },
        {
            text: 'Confidential records include the street address, mailing address, telephone number, e-mail address, social security number, or any other personal identifying information. Confidential information also includes provider’s names, addresses, and telephone numbers. In addition, the nature of covered services or any other information that may be deemed confidential or may be used to obtain confidential information will be protected. Finally, confidentiality includes the fact that we received a request or valid order of protection.'
        },
        {
            text: 'As part of the request, an alternative address, telephone number, or other method of contact will be accepted'
        }

    ]
    return (
        <div className='newyorkcustomer_wrapper'>
            <div className='border-table'>
                <table>
                    <tr>
                        <th colspan="2">
                            <div className='heading'>
                                <p><b>Applies To New York Customers<br />
                                    Confidentiality Protocols for Victims of Domestic Violence</b></p>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th>Description of New York, Regulation 168</th>
                        <td>
                            No individual shall be discriminated against in obtaining, retaining, or canceling an insurance policy or contract solely based on being a victim of domestic violence. In addition, as long as court-issued protection is in place for non-accident and health insurance (example life or annuity insurance) or a reasonable request for accident and health insurance (example dental, long term care or disability insurance) has been made for confidentiality due to domestic violence, the individual’s address and contact information will not be disclosed.
                        </td>
                    </tr>
                    <tr>
                        <th>New York Domestic Violence Hotline</th>
                        <td>
                            <div className='contacts'>
                                <p><b>Call </b> 1-800-942-6906</p>
                                <p><b>Text </b> 1-844-997-2121</p>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>Procedures for Handling a Request for address confidentiality due to Domestic Violence</th>
                        <td>
                            <div className='lists'>
                                <div className='itallic-heading'>
                                    <h2>All Confidential Protections will be implemented within three days.</h2>
                                </div>
                                <div className='list-items-wrapper'>
                                    {listtems.map((item, index) => (
                                        <div className='item-wraps' key={index}>
                                            <div className='list-number'>
                                                <div className='number-button'>
                                                    {index + 1}
                                                </div>
                                            </div>
                                            <div className='list-content'>{item.text}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>Who to Contact</th>
                        <td><b>Call</b> 1-800-473-6879</td>
                    </tr>
                </table>
            </div>
        </div>
    )
}

export default NewyorkCustomer;
